import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/Handlee/Handlee-Regular.ttf%22}]}],%22variableName%22:%22handlee%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'handlee', 'handlee Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
